import React, { useState, useEffect } from 'react';
import { Modal, Button } from '@prosolve/common-components-ui'
import { FaLink, FaExternalLinkAlt } from 'react-icons/fa';
import { getEnv } from '../../../utils'

export default ({
  assessmentName = '',
  onClose,
}) => {

  const env = getEnv()
  const url = `https://go.${env ? `${env}.` : ''}prosolve.com/survey?assessmentName=${assessmentName}`

  const text = 'To share a link to this assessment, go to:'

  const note = 'Note: Use caution when sharing this link since it will not contain additional data we often want to include in the url such as UserId, ClassId, Episode, etc, etc...'

  const [isLinkCopied, setIsLinkCopied] = useState(false)

  const onCopyLink = () => {
    if (!isLinkCopied) {
      navigator.clipboard.writeText(url)
      setIsLinkCopied(true)
    }
  }

  const onOpenLink = () => {
    window.open(url, "_blank")
    onClose()
  }

  useEffect(() => {
    if (isLinkCopied) {
      setTimeout(() => {
        onClose()
      }, 1000)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLinkCopied])

  return (
    <Modal title='' isFullScreen={true} onClose={onClose}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#565656'
      }}>
        <div style={{ 
          fontSize: '36px',
          color: '#565656',
          textAlign: 'center',
          position: 'absolute',
          top: '50px',
          width: '90%'
        }}>
          {note}
        </div>
        <div style={{ 
          fontSize: '36px',
          textAlign: 'center'
        }}>
          {text}
        </div>
        <div style={{
          fontSize: '36px',
          color: '#33AFE7',
          textAlign: 'center',
          wordBreak: 'break-word'
        }}>
          {url}
        </div>
        <div>
          <Button
            $colored={true}
            style={{
              marginTop: '20px',
              display: 'inline-flex',
              // height: '120px',
              padding: '12px 30px',
              border: 'none',
            }}
            onClick={onOpenLink}
          >
            <FaExternalLinkAlt style={{ marginRight: '15px', color: '#ffffff', fontSize: '28px' }} />
            <span style={{ fontSize: '28px', fontWeight: 'bold' }}>{'Open Link in New Tab'}</span>
          </Button>
          <Button
            $colored={true}
            $disabled={isLinkCopied}
            style={{
              marginTop: '20px',
              display: 'inline-flex',
              // height: '120px',
              padding: '12px 30px',
              border: 'none',
              marginLeft: '20px'
            }}
            onClick={onCopyLink}
          >
            <FaLink style={{ marginRight: '15px', color: '#ffffff', fontSize: '28px' }} />
            <span style={{ fontSize: '28px', fontWeight: 'bold' }}>{isLinkCopied ? 'Link copied to clipboard' : 'Copy Link'}</span>
          </Button>
        </div>
      </div>
    </Modal>
  )
}